import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { VendingPackageVolumeWeekdayHeatmapChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { getLast6MonthsChartRange } from '../../pudo/last-30-days-chart-range';
import { Last6MonthsVendingPackageVolumeWeekdayHeatmapChartProps } from './last-6-months-vending-package-volume-weekday-heatmap-chart.component';

export const useLast6MonthsVendingPackageVolumeWeekdayHeatmapChart = (props: Last6MonthsVendingPackageVolumeWeekdayHeatmapChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [rangeStart, setRangeStart] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before, rangeStart: alignedRangeStart } = getLast6MonthsChartRange();
        setRangeStart(alignedRangeStart);

        ChartClient.fetchChartData(props.accountId, VendingPackageVolumeWeekdayHeatmapChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return {
        data,
        isLoading,
        rangeStart
    };
};
